import { CreateExamOption } from "../exam/Exam";

export class UserInput {
    kind: number = 0;
    select_ids: SelectIDsInput = new SelectIDsInput();
    sinmulate: SimulateInput = new SimulateInput();
    bank: BankInput = new BankInput();
}

export class SelectIDsInput {
    ids: string[] = [];
    remove_correct_from_wrongs: boolean = false;
}

export class SimulateInput {
    option: CreateExamOption = new CreateExamOption();
}

export class BankInput {
    skips: Skips = new Skips();
}

export class Skips {
    full: SkipData = new SkipData();
    simulate: SkipData = new SkipData();
    old_pick: SkipData = new SkipData();
    pick: SkipData = new SkipData();
    best: SkipData = new SkipData();
}
export class SkipData {
    used: boolean = false;
    correct: boolean = false;
}
